import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    title: '80% weniger manueller Aufwand',
    description: 'Standardprozesse werden komplett automatisiert.'
  }, {
    title: 'Mehr Mandate bei gleicher Teamgröße',
    description: 'Höhere Kapazität ohne zusätzliches Personal.'
  }, {
    title: 'Schnellere Bearbeitung – mehr Umsatz',
    description: 'Mandate werden schneller angenommen und abgearbeitet.'
  }, {
    title: 'Kein IT-Projekt, keine Umstellung',
    description: 'Legallama setzt auf Ihr bestehendes System auf.'
  }, {
    title: 'Maximale Fehlerreduktion',
    description: 'Beweisbare Qualitätssteigerung bei Formalien und Dokumentation.'
  }, {
    title: 'DSGVO & Kanzleigeheimnis garantiert',
    description: 'Keine externe Cloud – keine externen KI-Dienste.'
  }];
  return <section className="py-20 bg-white" data-id="element-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-4">
          <h2 id="benefits" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-5">
            Ihre Vorteile – messbar, sofort und nachhaltig
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-6">
          {benefits.map((benefit, index) => <div key={index} className="bg-green-50 border-l-4 border-green-500 rounded-lg p-6" data-id="element-7">
              <div className="flex items-start gap-3" data-id="element-8">
                <span className="text-2xl" data-id="element-9">🟩</span>
                <div data-id="element-10">
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-11">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-700" data-id="element-12">{benefit.description}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}